import React from "react";
import "./NotFound.css"

export default function NotFound() {
  return (
    <div className="NotFound">
      <h2>404</h2>
      <p>Page not found</p>
    </div>
  );
}
